import React from "react";
import {
  Grid,
  Button,
  Typography,
  Collapse,
  Box,
  Container,
} from "@material-ui/core";

import { useTheme } from "@material-ui/core/styles";
import axios from "axios";
import DashboardSkeleton from "../../UI/Skeletons/DashboardSkeleton";
import AxiosErrorHandling from "../../components/AxiosErrorHandling/AxiosErrorHandling";
import moment from "moment";
import DateFnsUtils from "@date-io/date-fns";
import HorecaActivityTable from "./HorecaActivityTable";
import {
  MuiPickersUtilsProvider,
  KeyboardDatePicker,
} from "@material-ui/pickers";

import PeriodSelection from "../../components/PeriodSelection/PeriodSelection";
import ScorecardJobItem from "../../components/Scorecard/ScorecardJobItem";

const HorecaActivityReport = (props) => {
  const theme = useTheme();
  const [isLoading, setIsLoading] = React.useState(true);
  const [activityReport, setActivityReport] = React.useState([]);
  const [selectedPeriod, setSelectedPeriod] = React.useState("last7");
  const [reportPeriod, setReportPeriod] = React.useState({
    from: moment().subtract(7, "days").format("YYYY/MM/DD"),
    to: moment().format("YYYY/MM/DD"),
  });

  const [customDateFrom, setCustomDateFrom] = React.useState(
    moment().format("YYYY/MM/DD")
  );
  const [customDateTo, setCustomDateTo] = React.useState(
    moment().format("YYYY/MM/DD")
  );
  const [error, setError] = React.useState(null);

  React.useEffect(() => {
    reportPeriod === null
      ? getData(
          moment().subtract(7, "days").format("YYYY/MM/DD"),
          moment().format("YYYY/MM/DD")
        )
      : getData(reportPeriod.from, reportPeriod.to);
  }, [selectedPeriod]);

  const getData = (fromDate, toDate) => {
    setIsLoading(true);
    axios
      .get("/wp-json/api/v2/horeca_activity_report", {
        params: {
          from: fromDate ? moment(fromDate).format("YYYY/MM/DD") : null,
          to: toDate ? moment(toDate).format("YYYY/MM/DD") : null,
          companies: [],
        },
      })
      .then((res) => {
        setActivityReport(res.data);
        setIsLoading(false);
      })
      .catch((err) => {
        //since this is the first call, check for authetication error:
        setIsLoading(false);
        setError(err.response);
      });
  };

  const handlePeriodChange = (event) => {
    setSelectedPeriod(event.target.value);
    let localPeriod = {
      from: moment().subtract(7, "days").format("YYYY/MM/DD"),
      to: moment().format("YYYY/MM/DD"),
    };
    switch (event.target.value) {
      case "today":
        localPeriod = {
          from: moment().format("YYYY/MM/DD"),
          to: moment().format("YYYY/MM/DD"),
        };

        break;
      case "yesterday":
        localPeriod = {
          from: moment().subtract(1, "days").format("YYYY/MM/DD"),
          to: moment().format("YYYY/MM/DD"),
        };

        break;
      case "last7":
        localPeriod = {
          from: moment().subtract(7, "days").format("YYYY/MM/DD"),
          to: moment().format("YYYY/MM/DD"),
        };
        break;
      case "last28":
        localPeriod = {
          from: moment().subtract(28, "days").format("YYYY/MM/DD"),
          to: moment().format("YYYY/MM/DD"),
        };
        break;
      case "last90":
        localPeriod = {
          from: moment().subtract(90, "days").format("YYYY/MM/DD"),
          to: moment().format("YYYY/MM/DD"),
        };
        break;
      case "thisYear":
        localPeriod = {
          from: moment(`${moment().year()}/1/1`, "YYYY/MM/DD").format(
            "YYYY/MM/DD"
          ),
          to: moment(`${moment().year()}/12/31`, "YYYY/MM/DD").format(
            "YYYY/MM/DD"
          ),
        };
        break;

      default:
        localPeriod = {
          from: moment().subtract(7, "days").format("YYYY/MM/DD"),
          to: moment().format("YYYY/MM/DD"),
        };
        break;
    }
    setReportPeriod(localPeriod);
  };

  const handleCustomDateCollection = () => {
    //getDashboardData(customDateFrom, customDateTo);
  };

  const handleCancelDateCollection = () => {
    setCustomDateFrom(moment().format("YYYY/MM/DD"));
    setCustomDateTo(moment().format("YYYY/MM/DD"));
    setSelectedPeriod("today");
  };

  return (
    <Container maxWidth="xl">
      <Grid
        container
        justify="space-between"
        alignItems="center"
        className="test"
      >
        <Grid
          item
          xs={12}
          container
          direction="row"
          justify="flex-start"
          alignItems="flex-end"
        >
          <PeriodSelection
            label="Period"
            selectedPeriod={selectedPeriod}
            onPeriodChange={handlePeriodChange}
          />
          {/* <Box my={theme.spacing(2)}>
            <CoordinatorsDropdownMultipleSelection
              label={"Recruiter(s)"}
              selectedRecruiters={
                selectedCoordinator ? selectedCoordinator : ""
              }
              onRecruiterChange={handleChange}
              onClose={() =>
                getDashboardData(reportPeriod.from, reportPeriod.to)
              }
            />
          </Box> */}
        </Grid>
        <Grid item xs={12}>
          <Collapse in={selectedPeriod === "custom"}>
            <Box display="flex" alignItems="center">
              <MuiPickersUtilsProvider utils={DateFnsUtils}>
                <KeyboardDatePicker
                  disableToolbar
                  variant="inline"
                  format="yyyy/MM/dd"
                  margin="normal"
                  id="date-picker-from"
                  label="Start Date"
                  minDate={moment().subtract(365, "days").format("YYYY/MM/DD")}
                  maxDate={moment().format("YYYY/MM/DD")}
                  value={customDateFrom}
                  onChange={(date) => setCustomDateFrom(date)}
                  KeyboardButtonProps={{
                    "aria-label": "fromDate",
                  }}
                  style={{ marginTop: 8, marginRight: theme.spacing(2) }}
                />
                <KeyboardDatePicker
                  disableToolbar
                  variant="inline"
                  format="yyyy/MM/dd"
                  margin="normal"
                  id="date-picker-from"
                  label="Until"
                  minDate={moment(customDateFrom).format("YYYY/MM/DD")}
                  value={customDateTo}
                  onChange={(date) => setCustomDateTo(date)}
                  KeyboardButtonProps={{
                    "aria-label": "toDate",
                  }}
                  style={{ marginTop: 8, marginRight: theme.spacing(2) }}
                />
              </MuiPickersUtilsProvider>
              <Button
                variant="contained"
                color="primary"
                onClick={handleCustomDateCollection}
                style={{ marginRight: theme.spacing(3) }}
              >
                Apply
              </Button>
              <Button onClick={handleCancelDateCollection}>Cancel</Button>
            </Box>
          </Collapse>
        </Grid>
        {isLoading ? (
          <DashboardSkeleton
            open={true}
            style={{ marginTop: theme.spacing(4) }}
          />
        ) : (
          <Grid item xs={12} style={{ marginTop: theme.spacing(4) }}>
            <Box my={2} display="flex" alignItems={"center"}>
              <ScorecardJobItem
                label="Total Sent for Interview"
                value={
                  activityReport && activityReport.length
                    ? activityReport.filter(
                        (item) => item.event_key === "companySendToInterview"
                      ).length
                    : 0
                }
                color="#00B2FF"
              />
              <Box ml={2}>
                <ScorecardJobItem
                  label="Total Recruitments"
                  value={
                    activityReport && activityReport.length
                      ? activityReport.filter(
                          (item) =>
                            item.event_key === "companyRecruitmentSucceeded"
                        ).length
                      : 0
                  }
                  color="#A12CFF"
                />
              </Box>
            </Box>
            <Typography variant="h5" color="secondary">
              Horeca Activity Report
            </Typography>
            <Box mt={theme.spacing(2)}>
              <HorecaActivityTable data={activityReport}></HorecaActivityTable>
            </Box>
          </Grid>
        )}
        {error && (
          <AxiosErrorHandling
            title="Error occured in dashboard module"
            error={error}
          />
        )}
      </Grid>
    </Container>
  );
};
export default HorecaActivityReport;
